<template>
  <div>
    <Form class="m-t-15" :model="persion" label-position="right" :label-width="180">

      <FormItem label="证件类型：">
        <Dict v-model="persion.certType" dict="DictGb_personCertType" placeholder="请选择证件类型" style="width:60%"> </Dict>
      </FormItem>


      <FormItem label="选择上传方式：">
        <ButtonGroup>
          <Button :type="!certSelectType?'info':'default'" @click="certSelectType = 0">上传本地照片</Button>
          <Button :type="certSelectType==1?'info':'default'" @click="certSelectType = 1">读取高拍仪照片</Button>
          <Button :type="certSelectType==2?'info':'default'" v-show="persion.certType=='111'" @click="certSelectType = 2">读取二代证件</Button>
        </ButtonGroup>
      </FormItem>

      <FormItem label="证件照片：">
        <div class="p-10">
          <Row :gutter="10" v-show="!certSelectType">
            <Col span="12" class="text">
            <PhotoUpload v-model="persion.apPhotoCertFrontOss" :success="certFrontOssSuccess" :param="certFrontParam" type="drag">
              <div class="p-15">
                <div v-if="persion.apPhotoCertFrontOss" style="height:180px">
                  <img :src="persion.apPhotoCertFrontOss|img_oss('tubo_medium')" style="max-width:100%;max-height:100%">
                </div>
                <div class="p-30" v-else>
                  <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                  <h4>点击或将拖拽证件正面至此</h4>
                </div>
              </div>
            </PhotoUpload>
            </Col>
            <Col span="12">
            <PhotoUpload v-model="persion.apPhotoCertBackOss" type="drag">
              <div class="p-15">
                <div v-if="persion.apPhotoCertBackOss" style="height:180px">
                  <img :src="persion.apPhotoCertBackOss|img_oss('tubo_medium')" style="max-width:100%;max-height:100%">
                </div>
                <div class="p-30" v-else>
                  <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                  <h4>点击或将图片拖拽份证反面至此</h4>
                </div>
              </div>
            </PhotoUpload>
            </Col>
          </Row>

          <Row :gutter="10" v-show="certSelectType == 1">
            <Col span="12" class="text">
            <Card class="text-c c-h">
              <div @click="readCardFront">
                <div v-if="persion.apPhotoCertFrontOss" style="height:180px">
                  <img :src="persion.apPhotoCertFrontOss|img_oss('tubo_medium')" style="max-width:100%;max-height:100%">
                </div>
                <div class="p-30" v-else>
                  <Icon type="ios-camera" size="52" style="color: #3399ff"></Icon>
                  <h4>高拍仪读取证件正面</h4>
                </div>
              </div>
            </Card>

            </Col>
            <Col span="12" class="text">
            <Card class="text-c c-h">
              <div @click="readCardBack">
                <div v-if="persion.apPhotoCertBackOss" style="height:180px">
                  <img :src="persion.apPhotoCertBackOss|img_oss('tubo_medium')" style="max-width:100%;max-height:100%">
                </div>
                <div class="p-30" v-else>
                  <Icon type="ios-camera" size="52" style="color: #3399ff"></Icon>
                  <h4>高拍仪读取份证反面</h4>
                </div>
              </div>
            </Card>
            </Col>
          </Row>

          <Row :gutter="10" v-show="certSelectType == 2 ">
            <Col span="12" class="text">
            <Card class="text-c c-h">
              <div @click="readCardCert">
                <div v-if="persion.apPhotoCertFrontOss" style="height:180px">
                  <img :src="persion.apPhotoCertFrontOss|img_oss('tubo_medium')" style="max-width:100%;max-height:100%">
                </div>
                <div class="p-30" v-else>
                  <Icon type="md-wifi" size="52" style="color: #3399ff"></Icon>
                  <h4>二代证件读取</h4>
                </div>
              </div>
            </Card>
            </Col>
            <Col span="12" class="text">
            <div v-show="certSelectType == 2 && persion.apPhotoCertBackOss">
              <Card class="text-c c-h">
                <div @click="readCardCert">
                  <div v-if="persion.apPhotoCertBackOss" style="height:180px">
                    <img :src="persion.apPhotoCertBackOss|img_oss('tubo_medium')" style="max-width:100%;max-height:100%">
                  </div>
                  <div class="p-30" v-else>
                    <Icon type="md-wifi" size="52" style="color: #3399ff"></Icon>
                    <h4>二代身份读取</h4>
                  </div>
                </div>
              </Card>
            </div>
            </Col>
          </Row>

          <Row :gutter="10">
            <Col span="12" class="text">
            <div class="m-t-15 c-gray-6" v-show="persion.apPhotoCertFrontOss">
              <span>证件正面</span>
              <span @click="persion.apPhotoCertFrontOss = ''">
                <Icon class="m-l-30 c-h p-5" size="14" type="ios-close-circle"></Icon>
              </span>
            </div>
            </Col>
            <Col span="12" class="text">
            <div class="m-t-15 c-gray-6" v-show="persion.apPhotoCertBackOss">
              <span>证件反面</span>
              <span @click="persion.apPhotoCertBackOss = ''">
                <Icon class="m-l-30 c-h p-5" size="14" type="ios-close-circle"></Icon>
              </span>
            </div>
            </Col>
          </Row>

        </div>
      </FormItem>

      <FormItem label="现场照片对比结果：">
        <div class="p-10">
          <Row :gutter="10">
            <Col span="12" class="text">
            <Card class="text-c c-h">
              <div @click="readCardLive">
                <div v-if="persion.apPhotoOss" style="height:180px">
                  <img :src="persion.apPhotoOss|img_oss('tubo_medium')" style="max-width:100%;max-height:100%">
                </div>
                <div class="p-30" v-else>
                  <Icon type="ios-camera" size="52" style="color: #3399ff"></Icon>
                  <h4>摄像头读取现场照片</h4>
                </div>
              </div>
            </Card>
            </Col>
            <Col span="12" class="text">
            <Card class="text-c c-h">
              <div v-if="persion.apPhotoOss && persion.apPhotoCertFrontOss" style="height:180px">
                <img :src="persion.apPhotoMatch?staticPath.hotel.pass:staticPath.hotel.noPass" style="max-height:100%;max-width:100%">
              </div>
              <div class="p-15" v-else>
                <Icon type="ios-globe" size="52" style="color: #3399ff"></Icon>
                <h4>请上传证件正面和现场照片</h4>
                <Button type="default" @click="verify">对比</Button>
              </div>
            </Card>
            </Col>
          </Row>
        </div>
      </FormItem>

      <FormItem label="姓名：">
        <Input v-model="persion.apName" placeholder="请输入姓名" style="width:60%"></Input>
      </FormItem>

      <FormItem label="证件号码：">
        <Input v-model="persion.certNo" placeholder="请输入证件号码" style="width:60%"></Input>
      </FormItem>
      <FormItem label="手机号：">
        <Input v-model="persion.apPhone" placeholder="请输入姓名" style="width:60%"></Input>
      </FormItem>
    </Form>
  </div>
</template>
<script>
  import { staticPath } from '@/config'
  import { mapState } from 'vuex'
  import PhotoUpload from './PhotoUpload'
  import { dict } from '@/libs'
  export default {
    name: 'PersanCert',
    model: { prop: 'persion', event: 'change' },
    components: { PhotoUpload },
    props: {
      persion: { type: Object, required: true },
    },
    data() {
      return {
        staticPath,
        certFrontParam: {},
        certSelectType: 0
      }
    },
    watch: {
      persion(persion) {}
    },

    computed: {
      ...mapState({
        faceVerify: state => state.third.faceVerify,
      })
    },
    methods: {
      certFrontOssSuccess() {

      },
      readCardFront() {

      },
      readCardCert() {

      },
      readCardBack() {

      },
      readCardLive() {

      },
      verify() {

      }
    },
  }
</script>